import React from "react";
import { Box, Skeleton } from "@mui/material";
import useWindowSize from "shared/customHooks/windowSize";

// Fixed heights rather than random ones so the placeholder does not reshuffle
// on every re-render while the request is in flight.
const barHeights = [55, 80, 40, 95, 65, 30, 75, 50, 85, 45, 70, 60];

const xAxisHeight = 30;

// Stands in for shared/components/chart, matching the bar graph's height so the
// card does not resize once the real chart renders.
function ChartSkeleton() {
  const screenWidth = useWindowSize();
  const chartHeight = screenWidth > 500 ? 400 : 300;
  const bars = screenWidth > 500 ? barHeights : barHeights.slice(0, 7);

  return (
    <Box sx={{ display: "flex", height: `${chartHeight}px` }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          marginRight: "12px",
          paddingBottom: `${xAxisHeight}px`,
        }}
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} variant="text" width={22} height={12} />
        ))}
      </Box>

      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: "8px",
            height: `${chartHeight - xAxisHeight}px`,
          }}
        >
          {bars.map((height, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                flex: 1,
                height: `${height}%`,
                borderRadius: "2px 2px 0 0",
              }}
            />
          ))}
        </Box>

        <Box sx={{ display: "flex", gap: "8px", marginTop: "8px" }}>
          {bars.map((_, index) => (
            <Skeleton
              key={index}
              variant="text"
              height={12}
              sx={{ flex: 1 }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default ChartSkeleton;
